export const PINNED_CHALLENGE_USERS_STORAGE_KEY = "challengePinnedUsers";
export const PINNED_CHALLENGE_USERS_CHANGED_EVENT = "challengePinnedUsersChanged";
export const CHALLENGE_MODAL_SHOWN_SESSION_KEY = "challengeModalShownThisLogin";

const uniqueUsernames = (value) => {
  const usernames = Array.isArray(value) ? value : [];
  const seen = new Set();

  return usernames.reduce((result, username) => {
    const value = String(username || "").trim();
    const key = value.toLowerCase();
    if (!value || seen.has(key)) return result;
    seen.add(key);
    result.push(value);
    return result;
  }, []);
};

export const getPinnedChallengeUsers = () => {
  try {
    return uniqueUsernames(
      JSON.parse(window.localStorage.getItem(PINNED_CHALLENGE_USERS_STORAGE_KEY) || "[]")
    );
  } catch {
    return [];
  }
};

export const savePinnedChallengeUsers = (usernames) => {
  const nextUsernames = uniqueUsernames(usernames);
  window.localStorage.setItem(
    PINNED_CHALLENGE_USERS_STORAGE_KEY,
    JSON.stringify(nextUsernames)
  );
  window.dispatchEvent(new Event(PINNED_CHALLENGE_USERS_CHANGED_EVENT));
  return nextUsernames;
};

// Logout must remove the auth/session state without removing the Tech Admin's
// deliberately pinned challengers.
export const clearSessionStorageKeepingPinnedUsers = () => {
  let pinnedUsers = null;
  try {
    pinnedUsers = window.localStorage.getItem(PINNED_CHALLENGE_USERS_STORAGE_KEY);
    window.localStorage.clear();
    if (pinnedUsers !== null) {
      window.localStorage.setItem(PINNED_CHALLENGE_USERS_STORAGE_KEY, pinnedUsers);
    }
  } catch {
    // Logout must continue even if browser storage is unavailable/restricted.
  }
  try {
    window.sessionStorage.removeItem(CHALLENGE_MODAL_SHOWN_SESSION_KEY);
  } catch {
    // Ignore storage restrictions; Redux logout still completes.
  }
};

export const resetChallengeModalForLogin = () => {
  window.sessionStorage.removeItem(CHALLENGE_MODAL_SHOWN_SESSION_KEY);
};
